module.exports = __webpack_public_path__ + "img/clock.1ac78f00.svg";